import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

import { reformatLot } from '../../../selectors/lots'

const initial = {
  info: {},
  lots: [],
  active: null,
  init: false
}

const getActions = generateActions('persons/info/GET_INFO')
const getLotsActions = generateActions('persons/info/GET_LOTS')
const subscribeActions = generateActions('persons/info/SUBSCRIBE')
const getActiveLotActions = generateActions('persons/info/GET_ACTIVE_LOT')

export const get = createAction(
  API_CONST,
  personId => ({
    actions: getActions,
    url: `persons/${personId}`
  })
)

export const getLots = createAction(
  API_CONST,
  personId => ({
    actions: getLotsActions,
    url: `persons/${personId}/lots`
  })
)

export const getActiveLot = createAction(
  API_CONST,
  personId => ({
    actions: getActiveLotActions,
    url: `persons/${personId}/activeLot`
  })
)

export const subsribe = createAction(
  API_CONST,
  (personId, flag) => ({
    method: 'POST',
    actions: subscribeActions,
    params: { doSubscribe: flag },
    url: `persons/${personId}/changeSubscribe`
  }),
  (personId, flag) => ({ flag })
)

const reformatLots = items => items.map(item => ({
  _id: item._id,
  name: item.fund.name,
  targetId: item.fund._id,
  date: item.closeDate,
  sum: item.bidsStats.bidSum,
  currency: item.bidsStats.currencySymbol
}))

export default handleActions({
  [getActions[0]]: state => ({ ...initial }),
  [getActions[1]]: (state, { payload = {} }) => ({
    ...state,
    info: payload,
    init: true
  }),
  [getActions[2]]: state => ({
    ...initial,
    init: true
  }),
  [getLotsActions[0]]: state => ({
    ...state,
    lots: []
  }),
  [getLotsActions[1]]: (state, { payload = [] }) => ({
    ...state,
    lots: reformatLots(payload)
  }),
  [subscribeActions[1]]: (state, { meta }) => ({ ...state, info: { ...state.info, isSubscribed: meta.flag } }),
  [getActiveLotActions[0]]: state => ({ ...state, active: null }),
  [getActiveLotActions[1]]: (state, { payload = [] }) => ({
    ...state,
    active: payload.length
      ? reformatLot(payload[0])
      : null
  })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/persons/info.js